/**
 * Shared radio-style toggle pill used on edit pages (status, flags, etc.).
 */
export function renderEditToggle(options) {
    return `
        <label class="edit-toggle" data-bind="css: { 'is-selected': ${options.selectedBinding} }">
            ${options.inputHtml}
            <span class="edit-toggle__control" aria-hidden="true"></span>
            ${options.labelHtml}
        </label>
    `;
}
